import { useActiveOrg } from '~/hooks/org/useActiveOrg'
import { useAuthUser } from '~/hooks/useAuthUser'
import { OrgMember, OrgMemberRole, UserKind } from '~/types'

export const useActiveOrgMember = (): OrgMember | undefined => {
  const { org: activeOrg } = useActiveOrg()
  const { user: authUser } = useAuthUser()
  const activeOrgMember = activeOrg?.members.find(
    (member) => member.id === authUser?.id,
  )

  if (activeOrgMember) return activeOrgMember

  const isViewingAsAdmin =
    authUser?.isSplitsAdmin &&
    activeOrg &&
    !authUser.orgs.some((org) => org.id === activeOrg.id)

  if (!isViewingAsAdmin) return undefined

  return {
    id: authUser.id,
    kind: UserKind.Human,
    email: authUser.email,
    displayName: authUser.displayName,
    profilePhotoUrl: authUser.profilePhotoUrl,
    createdAt: authUser.createdAt,
    role: OrgMemberRole.Owner,
  }
}
